import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q6: PartialCarConfiguration = {
	nextBestActions: [
		{
			icon: '',
			description: 'Register your interest',
			labelText: 'Register your interest',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.co.uk/uk/web/en/register-your-interest.html?carlineId={{carlineId}}',
		},
		{
			icon: 'hotline',
			description: 'Speak to your local Audi Centre',
			labelText: 'Contact Audi Centre',
			target: '_blank',
			trackingName: 'poa link',
			url: 'https://www.audi.co.uk/uk/web/en/call-me-back.html?',
		},
		{
			icon: 'test-drive',
			description: 'Request a callback regarding your Audi',
			labelText: 'Request a callback',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://www.audi.co.uk/uk/web/en/call-me-back.html?carlineId={{carlineId}}',
		},
		{
			icon: 'wallbox',
			description: 'Discover financing options and special offers',
			labelText: 'Finance & offers',
			target: '_blank',
			trackingName: 'online leasing',
			url: 'https://www.audi.co.uk/uk/web/en/electric/offers-and-incentives.html',
		},
	],
	summaryFooterCta: {
		icon: 'test-drive',
		description: 'Request a callback regarding your Audi',
		labelText: 'Request a callback',
		target: '_blank',

		trackingName: 'testdrive',
		url: 'https://www.audi.co.uk/uk/web/en/call-me-back.html?carlineId={{carlineId}}',
	},
	stockCarConfig: {
		enabled: false,
		disclaimer: false,
		geoFilter: false,
		priceFilter: { min: 0, max: 0 },
		subheader: false,
		url: '',
		pricedisclaimer: false,
	},
	combinations: ['trimLine', 'paint[bodyPaint]', 'rims', 'interiorPackages', 'packages'],
};

const sq6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron: PartialCarConfiguration = {
	...q6,
};

export { q6etron, sq6etron };
